export const AnchorLinkController = () => {
  $('a[href^="#"]').on('click', (e) => {
    e.preventDefault();
    const target = $(e.currentTarget).attr('href');
    const headerHeight = $('.header__top').height();

    $('html, body').animate({
      scrollTop: $(target).offset().top - headerHeight
    }, 300, () => {

    });

  });
}



// WEBPACK FOOTER //
// ./src/js/controllers/AnchorLinkController.js